import * as enquire from 'enquire.js';

function initHeroImage(){
	let $video:any = $('.js-desktop-video');
	let mobileSrc = $video.data('mobile-src');
	let desktopSrc = $video.data('desktop-src');

	enquire.register("screen and (max-width:767px)", {
		match: function() {
			$video.find('source').attr('src', mobileSrc);
			$video[0].load();
		},
		unmatch: function() {
			$video.find('source').attr('src', desktopSrc);
			$video[0].load();
		},
	});




}

export function init() {
	if($('.js-desktop-video').data('mobile-src')) {
		initHeroImage();
	}
}
